import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { MdOutlineCloudUpload } from 'react-icons/md'; // Cloud-Based Model Deployment
import { MdOutlineDevices } from 'react-icons/md'; 
import img1 from "../../../assets/img/Industries/Healthcare/blcok_security.jpg"
import { AiOutlineLock } from 'react-icons/ai';
import { FaTruck } from 'react-icons/fa';
import { FaFileContract } from 'react-icons/fa';

export default function MainSection4() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Blockchain for Security and Transparency
            </h1>
            <p className="text-lg text-gray-600">
            Ensuring data security, supply chain transparency, and transaction efficiency in healthcare with blockchain and smart contract technology.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineLock className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Data Privacy and Security</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Protect sensitive medical records with tamper-proof blockchain technology.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaTruck className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Supply Chain Integrity</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Track pharmaceuticals and medical equipment to prevent counterfeiting and ensure transparency.
              </p>
            </div>
{/* Feature 3 */}
<div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaFileContract className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Smart Contracts</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Streamline claims and automate complex transactions for payers and insurers.
              </p>
            </div>
      
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  )
}